/**
 * @file iframeApiMessage constants used to communicate API responses inside message composer iframes to the dashboard.
 */
/**
 * iframeApiMessage types used to differentiate between request types
 * @note all types should have a `braze` prefix like `brazeApiRequest`
 */
export const iframeApiMessage = {
  apiRequest: "brazeApiRequest",
  apiResponse: "brazeApiResponse",
} as const;
